import React, { useState } from "react";
import { Form, Input, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "../driverForm.css"
import axios from "axios";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import { storage } from "../../../../../scopedStorage";

const { Option } = Select;

function getBase64(file, cb) {
    const reader = new FileReader();
    reader.addEventListener("load", () => cb(reader.result));
    reader.readAsDataURL(file);
}



const CreateDriverModal = ({ handleCloseDriver, showDriver }) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [driverImageFile, setDriverImageFile] = useState(null);
    const [driversName, setDriversName] = useState("");
    const [driversPhone, setDriversPhone] = useState("");
    const [plate, setPlate] = useState("");
    const [type, setType] = useState("");

    // const handleImageBeforeUpload = (file) => {
    //     getBase64(file, (url) => setImageUrl(url));
    //     return false;
    // };

    const handleImageBeforeUpload = (file) => {
        // store the file for upload
        setDriverImageFile(file);

        // create a preview URL (no base64)
        const previewUrl = URL.createObjectURL(file);
        setImageUrl(previewUrl);

        // prevent AntD from auto-uploading
        return false;
    };

    const handleUploadDriversImage = async () => {
        if (!driverImageFile) {
            // no file selected
            toast.error("Please select an image first");
            return;
        }

        const formData = new FormData();
        // adjust field name ("image") to what your backend expects
        formData.append("file", driverImageFile);

        setLoading(true);
        const token = storage.getItem("token");
        const toastConfig = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            progress: undefined,
            theme: "light",
        };

        try {
            const response = await axios.post(
                `${switchEndpoint}/upload-image`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // ❗ DO NOT manually set "Content-Type": axios will set the correct multipart boundary
                    },
                }
            );

            const { data } = response;
            const uploadedUrl = data?.image_url;
            handleRegisterDriverWithImage(uploadedUrl);
        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.data?.message || "Failed to upload image",
                toastConfig
            );
        } finally {
            setLoading(false);
        }
    };

    // const handleUploadDriversImage = async () => {
    //     let payload = {
    //         image_url: imageUrl || ""
    //     }
    //     setLoading(true);
    //     const token = storage.getItem("token");
    //     const toastConfig = {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         pauseOnHover: true,
    //         progress: undefined,
    //         theme: "light",
    //     };

    //     try {
    //         const response = await axios.post(`${switchEndpoint2}/api/upload-image`, payload, {
    //             headers: { Authorization: `Bearer ${token}` },
    //         });
    //         const { data } = response;
    //         setLoading(false);
    //         toast.success(data?.message || "Driver created successfully!", toastConfig);
    //         handleCloseDriver();
    //     } catch (error) {
    //         toast.error(error?.response?.data?.message, toastConfig);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleRegisterDriverWithImage = async (image) => {
        let payload = {
            name: driversName,
            phone: driversPhone,
            vehicle_number: plate,
            vehicle_type: type,
            image_url: image
        }
        setLoading(true);
        const token = storage.getItem("token");
        const toastConfig = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            progress: undefined,
            theme: "light",
        };

        if (driversPhone.length < 11) {
            toast.error("Driver's phone number must be at least 11 characters!", toastConfig);
            return;

        }
        if (!driversName) {
            toast.error("Driver's name is required!", toastConfig);
            return;

        }
        if (!plate) {
            toast.error("Plate number is required!", toastConfig);
            return;

        }
        if (!type) {
            toast.error("Vehicle type is required!", toastConfig);
            return;

        }

        try {
            const response = await axios.post(`${switchEndpoint}/factory/create-driver`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const { data } = response;
            setLoading(false);
            toast.success(data?.message || "Driver created successfully!", toastConfig);

            // setImageUrl("");
            handleCloseDriver();
            window.location.reload();
        } catch (error) {
            toast.error(error?.response?.data?.message, toastConfig);
        } finally {
            setLoading(false);
        }
    };

    const handleRegisterDriverWithoutImage = async () => {
        const toastConfig = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            progress: undefined,
            theme: "light",
        };
        if (driversPhone.length < 11) {
            toast.error("Driver's phone number must be at least 11 characters!", toastConfig);
            return;

        }
        if (!driversName) {
            toast.error("Driver's name is required!", toastConfig);
            return;

        }
        if (!plate) {
            toast.error("Plate number is required!", toastConfig);
            return;

        }
        if (!type) {
            toast.error("Vehicle type is required!", toastConfig);
            return;

        }
        let payload = {
            name: driversName,
            phone: driversPhone,
            vehicle_number: plate,
            vehicle_type: type,
            image_url: ""
        }
        setLoading(true);
        const token = storage.getItem("token");


        try {
            const response = await axios.post(`${switchEndpoint}/factory/create-driver`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const { data } = response;
            setLoading(false);
            toast.success(data?.message || "Driver created successfully!", toastConfig);
            handleCloseDriver();
            window.location.reload();
        } catch (error) {
            toast.error(error?.response?.data?.message, toastConfig);
        } finally {
            setLoading(false);
        }
    };


    const digitsOnlyMax11 = (value = "") => String(value).replace(/\D/g, "").slice(0, 11);
    return (
        <div>
            <Modal
                show={showDriver}
                onHide={() => {
                    handleCloseDriver();
                    window.location.reload();
                }}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <div class="modal-header">
                    <h5 class="modal-title">Create Driver</h5>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            handleCloseDriver();
                            window.location.reload();
                        }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <Modal.Body>
                    <div className="mx-2">
                        <Form
                            layout="vertical"
                            // onFinish={onFinish}
                            className="driver-form"
                        >
                            <div className="driver-form-grid">
                                <Form.Item
                                    label="Driver Name"
                                    name="driverName"
                                    rules={[{ required: true, message: "Please enter driver name" }]}
                                >
                                    <input
                                        type="text"
                                        className="form-control inputStyle"
                                        placeholder="Enter driver name"
                                        no-border
                                        value={driversName}
                                        onChange={(e) => setDriversName(e.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Driver Phone Number"
                                    name="driverPhone"
                                    normalize={digitsOnlyMax11}
                                    rules={[
                                        { required: true, message: "Please enter driver phone number" },
                                        { len: 11, message: "Phone number must be exactly 11 digits" }, // blocks submit if < 11 or > 11
                                        { pattern: /^\d+$/, message: "Only numbers are allowed" },
                                    ]}
                                >
                                    <input
                                        type="numeric"
                                        maxLength={11}
                                        autoComplete="tel"
                                        className="form-control inputStyle"
                                        placeholder="Enter driver phone number"
                                        no-border
                                        value={driversPhone}
                                        onChange={(e) => setDriversPhone(e.target.value)}
                                    />
                                </Form.Item>
                            </div>

                            <div className="driver-form-grid">
                                <Form.Item
                                    label="Vehicle Plate No"
                                    name="vehiclePlate"
                                    rules={[{ required: true, message: "Please enter vehicle plate no" }]}
                                >
                                    <input
                                        type="text"
                                        className="form-control inputStyle"
                                        placeholder="Enter vehicle plate no"
                                        no-border
                                        value={plate}
                                        onChange={(e) => setPlate(e.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Vehicle Type"
                                    name="vehicleType"
                                    rules={[{ required: true, message: "Please select vehicle type" }]}
                                >
                                    <Select placeholder="Select vehicle type" value={type}
                                        onChange={(value) => setType(value)}>
                                        <Option value="tricycle">Tricycle</Option>
                                        <Option value="truck">Truck</Option>
                                        {/* <Option value="bike">Bike</Option> */}
                                    </Select>
                                </Form.Item>
                            </div>

                            {/* Upload card */}
                            {/* <Form.Item label="">
                                <Upload
                                    accept="image/*"
                                    showUploadList={false}
                                    beforeUpload={handleImageBeforeUpload}
                                    className="driver-upload-wrapper"
                                >
                                    <div className="driver-upload-card">
                                        <div className="driver-upload-avatar-wrapper">
                                            {imageUrl ? (
                                                <img
                                                    src={imageUrl}
                                                    alt="Driver"
                                                    className="driver-upload-avatar"
                                                />
                                            ) : (
                                                <div className="driver-upload-avatar driver-upload-avatar--placeholder">
                                                    <UploadOutlined style={{ fontSize: 32 }} />
                                                </div>
                                            )}
                                        </div>

                                        <div className="driver-upload-text-main">
                                            Click to Upload Driver Image
                                        </div>
                                        <div className="driver-upload-text-sub">Optional</div>
                                    </div>
                                </Upload>
                            </Form.Item> */}

                            <Form.Item label="">
                                <Upload
                                    accept="image/*"
                                    showUploadList={false}
                                    beforeUpload={handleImageBeforeUpload}
                                    className="driver-upload-wrapper"
                                >
                                    <div className="driver-upload-card">
                                        <div className="driver-upload-avatar-wrapper">
                                            {imageUrl ? (
                                                <img
                                                    src={imageUrl}
                                                    alt="Driver"
                                                    className="driver-upload-avatar"
                                                />
                                            ) : (
                                                <div className="driver-upload-avatar driver-upload-avatar--placeholder">
                                                    <UploadOutlined style={{ fontSize: 32 }} />
                                                </div>
                                            )}
                                        </div>

                                        <div className="driver-upload-text-main">
                                            Click to Upload Driver Image
                                        </div>
                                        <div className="driver-upload-text-sub">Optional</div>
                                    </div>
                                </Upload>
                            </Form.Item>

                            <button
                                type="button"
                                className="btn loginBtn btn-sm btn-block w-25"
                                onClick={() => {
                                    if (imageUrl) {
                                        handleUploadDriversImage();
                                    } else {
                                        handleRegisterDriverWithoutImage();
                                    }

                                }}
                                disabled={loading}
                            >
                                Register Driver
                            </button>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )

}

export default CreateDriverModal;